/**
 * Free trial sign-up (3 months free).
 *
 * Sign-up is handled entirely by the dashboard - the site no longer hosts its
 * own sign-up form. Always open this in a new tab so visitors keep the
 * marketing site behind them.
 */
export const SIGNUP_URL = 'https://dashboard.personalia.io/signup';
